import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { currentSession } from 'aws-auth-lib';
import Loader from '../components/Loader';

const PublicRoute = () => {
    const [checking, setChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        let mounted = true;
        currentSession()
            .then((session) => {
                if (!mounted) return;
                setIsAuthenticated(Boolean(session));
            })
            .catch(() => {
                if (!mounted) return;
                setIsAuthenticated(false);
            })
            .finally(() => {
                if (!mounted) return;
                setChecking(false);
            });

        return () => {
            mounted = false;
        };
    }, []);

    if (checking) return <Loader />;

    return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
};

export default PublicRoute;
